/**
 * Browser Supabase client (anon key). All queries respect RLS.
 * Service-role operations belong in Vercel handlers under api/, not here.
 */
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY


export const supabase = createClient(supabaseUrl, supabaseAnonKey)

